<template>
    <Drawer v-model:visible="visibleRight" position="left" class="drawerWrapper">
        <template #header>
            <i style="position: absolute; top: 16px; left: 15px; font-size: 22px;color: rgb(127, 150, 172)" class="pi pi-sitemap"></i>
            <h2 style="font-size: 22px; margin: 0; position: absolute; top: 13px; left: 52px; font-family: 'Satoshi-Medium';color: rgb(127, 150, 172)">Poe kategooriad</h2>
        </template>
        <!-- <img 
            class="coverImg" 
            v-if="shopData"
            :src="`${$fetchIp}/static/images/shops/${shopData.coverImg}`"
        >
        <div 
            class="singleCat" 
            :class="{'activeCategory': !activeCategory}" 
            @click="resetCategory(); visibleRight = false"
        >
            <img 
                :src="require('../../assets/menuIcons/biscuit.svg')" 
                alt=""
            >
            <p>{{ $t('buttons.allCategories') }}</p>
        </div>
        <div 
            class="singleCat" 
            :class="{'activeCategory': activeCategory === element.idListingTag}" 
            v-for="element of categories" :key="element.id"
            @click="categoryChange(element.idListingTag); visibleRight = false"
        >
            <img 
                :src="require('../../assets/menuIcons/biscuit.svg')" 
                alt=""
            >
            <p>{{ element.name }}</p>
        </div> -->
        <img 
            class="coverImg" 
            :src="require('../../assets/vegotarLong.png')" 
        >
        <div class="menuContent">
            <div 
                class="singleCat" 
                :class="{'activeCategory': !activeCategory}" 
                @click="resetCategory(); visibleRight = false"
            >
                <img 
                    :src="require('../../assets/menuIcons/biscuit.svg')" 
                    alt=""
                >
                <p>{{ $t('buttons.allCategories') }}</p>
            </div>
            <div 
                class="singleCat" 
                :class="{'activeCategory': activeCategory === element.idListingTag}" 
                v-for="element of categories" 
                :key="element.id" 
                @click="categoryChange(element.idListingTag); visibleRight = false"
            >
                <img 
                    :src="require('../../assets/menuIcons/biscuit.svg')" 
                    alt=""
                >
                <p>{{ element.name }}</p>
            </div>
        </div>
        <div class="line"></div>
        <div class="businessData">
            <p>Vegotar Tööstusautomaatika OÜ</p>
            <p>Rannaküla, 61012 Tartu County</p>
            <p>+372 523 7371</p>
        </div>
        <div class="bottomMessage">
            <h2>{{ $t('contact.question') }}</h2>
            <p>{{ $t('contact.title') }}</p>
            <Button @click="$emit('openContactPopup')" :label="$t('buttons.contactUsAlt')" severity="contrast" icon="pi pi-envelope" />
        </div>
    </Drawer>
</template>

<script>
import Drawer from 'primevue/drawer';
import Button from 'primevue/button'

export default {
    name: 'categoriesDrawer',
    components: {
        Drawer,
        Button
    },
    props: {
        categories: null,
        shopData: null
    },
    watch: {
        visibleRight(newValue) {
            if(newValue == false) {
                this.$emit('sidebarVisibility')
            }
        }
    },
    data() {
        return {
            visibleRight: false,
        }
    },

    methods: {
        categoryChange(idListingTag) {
            if(this.activeCategory == idListingTag) {
                if(this.currentRouteName != 'catalogPage') {
                    this.$router.push({name: 'catalogPage'})
                }
                setTimeout(() => {
                    this.activeCategory = null
                    this.$emit('categoryChange', false)
                }, 1);
            } else {
                if(this.currentRouteName != 'catalogPage') {
                    this.$router.push({name: 'catalogPage'})
                }
                setTimeout(() => {
                    this.activeCategory = idListingTag
                    this.$emit('categoryChange', idListingTag)
                
                }, 1);
            }
        },

        resetCategory() {
            setTimeout(() => {
                this.activeCategory = null
                this.$emit('categoryChange', false)
            }, 1);
        }
    },

    created() {
    }
       
}
</script>

<style>
.emptyNotice .pi.pi-cart-arrow-down.p-button-icon.p-button-icon-left {
    font-size: 20px;
    margin-right: -3px;
}
</style>
<style>
.p-drawer.p-component.drawerWrapper {
    width: 350px;
}
</style>
<style scoped>
.shape {
    position: absolute;
    z-index: 0;
    left: 0;
    width: 100%;
    height: 185px;
    background: rgb(255, 255, 255);
}
.menuContent {
    padding-top: 25px;
    height: 370px;
    overflow-x: scroll;
}
.coverImg {
    position: relative;
    z-index: 1;
    width: 100%;
    margin-top: 30px;
    margin-bottom: 10px;
    padding-bottom: 0px;
}
.line {
    height: 1px;
    width: calc(100% - 25px);
    margin-right: 25px;
    background: rgb(202, 212, 224);
}
.businessData {
    margin-top: 25px;
    text-align: center;
    padding-right: 25px;
}
.businessData p {
    margin: 0;
    margin-top: 7px;
    color: rgb(119, 126, 134);
    font-family: 'Nunito', sans-serif;
}
.businessData p:first-child {
    font-weight: bold;
}
.singleCat {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 20px;
    padding-left: 10px;
    padding-top: 7px;
    padding-bottom: 7px;
}
.singleCat img {
    width: 45px;
    height: 45px;
}
.singleCat p {
    font-family: 'Satoshi-Medium';
    color:  #22262A;
    margin: 0;
    margin-top: 10px;
    margin-left: 25px;
    font-size: 17px;
    text-transform: capitalize;
}
.singleCat:hover {
    cursor: pointer;
}
.singleCat:hover  p {
    color:  #2b6fb4;
}
.activeCategory {
    background: #eff5f8;
    padding-left: 10px;
    margin-left: 0px;
    width: 100%;
    border-radius: 48px ;
}
.activeCategory p {
}
.activeCategory
.activeCategory:hover p {
    color: white;
}
.bottomMessage {
    border: 1px solid rgb(222, 230, 240);
    margin-right: 25px;
    border-radius: 30px;
    margin-top: 25px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 5px;
    padding-bottom: 25px;
    text-align: center;
    background: #F7FBFD;
}
.bottomMessage h2 {
    font-size: 20px;
    font-weight: bold;
    font-family: 'Nunito', sans-serif;
    color: #2a3949;
}
.bottomMessage p {
    font-family: 'Nunito', sans-serif;
    font-size: 16px;
    color: #6a7a8a;
}
.bottomMessage button {
    width: 100%;
}

</style>
